exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hos-info-name[data-v-62f3aa69]{border-bottom:.026667rem solid #d7d7d7;padding:.5rem 0;margin:0 .5rem}.hos-info-image[data-v-62f3aa69]{padding:.5rem}.hos-info-image img[data-v-62f3aa69]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62f3aa69","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/hospitalinfo/HosInfo.vue
// module id = 457
// module chunks = 0